import { useQuery } from '@tanstack/react-query'
import { getDepartmentList } from 'services/api/messagesApi'

const useGetDepartmentList = () => {
  return useQuery({
    queryKey: [`get-department-list`],
    queryFn: getDepartmentList,
    select: (data) => data,
    retry: true,
    staleTime: 2 * (60 * 1000), // 2 mins
    cacheTime: 4 * (60 * 1000), // 4 mins
  })
}

export default useGetDepartmentList
